
export default function BenefitsOfPvrCabs() {
    const features = [
        {
            icon: '/icons/FleetOptimization.png',
            title: 'Fleet Optimization',
            description: 'Our service ensures efficient management and utilization of vehicles to meet your transportation needs effectively.',
        },
        {
            icon: '/icons/Routing_Planning.png',
            title: 'Routing & Planning',
            description: 'We employ advanced routing and planning techniques to ensure timely and optimized routes for your journeys.',
        },
        {
            icon: '/icons/DiverseFleet.png',
            title: 'Diverse Fleet Options',
            description: 'Choose from a wide range of vehicles in our fleet, catering to different group sizes and preferences.',
        },
        {
            icon: '/icons/ExperiencedChauffeurs.png',
            title: 'Experienced Chauffeurs',
            description: 'Our professional chauffeurs are highly experienced and trained to provide safe and reliable transportation services.',
        },
        {
            icon: '/icons/CustomizedPackages.png',
            title: 'Customized Packages',
            description: 'We offer tailored packages to suit your specific requirements, ensuring flexibility and convenience.',
        },
        {
            icon: '/icons/Licensed Partnerships.png',
            title: 'Licensed Partnerships',
            description: 'We have established tie-ups with licensed transportation companies, ensuring compliance and reliability in our services.',
        },
        {
            icon: '/icons/HassleFreeBilling.png',
            title: 'Convenient Billing Process',
            description: 'Our billing process is streamlined and hassle-free, providing you with convenience and transparency in transactions.',
        },
        {
            icon: '/icons/ReliableService.png',
            title: 'Reliable Service',
            description: 'Experience the convenience and reliability of PVR CABS Transport Service for all your transportation needs.',
        }
    ];

    return (
        <div className="py-10 md:py-14 bg-white">
            <div className="text-center">
                <div className="flex justify-center items-center p-2 w-fit mx-auto shadow-sm rounded-full">
                    <img src="/pngegg.png" width="100%" className="w-8 h-8 md:w-10 md:h-10" />
                    {/* <img src="/icons/TransportServiceIcon.png" width="100%" className="w-6 h-6" /> */}
                </div>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-blue-950 mt-2">
                    Benefits of PVRCabs Transport Service
                </h2>
                <p className="text-sm md:text-base lg:text-lg mt-1 w-[95%] md:w-[90%] lg:w-[80%] mx-auto">
                    PVRCabs offers dependable employee transportation with real-time vehicle tracking, professional drivers, and a fully compliant fleet-ensuring safe, timely commutes for leading companies across Hyderabad and the Telangana region.
                </p>
            </div>
            <div className="w-[80%] md:w-[90%] lg:w-[70%] mx-auto mt-10">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-10 mx-auto">
                    {features.map((item, index) => (
                        <div key={index}>
                            <div className="flex flex-row justify-center items-start gap-2">
                                <div className="bg-white p-1 md:p-2 border-2 border-gray-400 shadow-sm shadow-teal-100 rounded-md md:rounded-2xl">
                                    <img src={`${item.icon}`} width="100%" className="w-6 md:w-10" />
                                </div>
                                <div className="flex-1">
                                    <h2 className="text-xs md:text-sm lg:text-[16px] mt-[2px] font-semibold">{item.title}</h2>
                                    <p className="text-xs md:text-sm mt-[2px]">{item.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>



        </div>
    )
}